import React from "react";
import { copyToClipboard } from "../../../utils/copyToClipboard";
import API from "../../../services/api";
import { Toast } from "../../../shared/Toast";
import { roles } from "../../../utils/constants";

const handleApproveContent = async (creative_id, content_id,approve,head_line,description,onClose) => {
  console.log(approve)
  const result = await API({
    url: "/alpha_cst_designer/approveContent",
    method: "POST",
    responseType: "json",
    data: { creative_id, content_id, approve, headline:head_line, description },
  });
  if (result.status === "SUCCESS") {
    onClose();
    Toast("success", "Content Approved SuccessFully");
  } else {
    Toast("error", "Failed To Approve Content");
  }
};

const ContentDetailsModal = ({ isOpen, onClose, contentList, data }) => {
  if (!isOpen) return null;
  const hasContent = contentList && contentList.length > 0;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div className="bg-white rounded-xl shadow-2xl w-11/12 max-w-3xl p-6 relative overflow-y-auto max-h-[90vh]">
        {/* Header */}
        <div className="flex justify-between items-center mb-6 border-b border-gray-200 pb-3">
          <h2 className="text-2xl font-bold text-gray-800">Content Details</h2>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-600 p-2 rounded-full transition" aria-label="Close modal">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>

        {/* Content */}
        {hasContent ? (
          <div className="space-y-6">
            {contentList.map((contentItem, contentIndex) => (
              <div key={contentIndex} className="px-4 py-2 bg-gray-50 rounded-lg shadow-inner flex flex-col items-start justify-center">
                <div className="mb-4">
                  <h3 className="text-lg font-semibold text-gray-700">Content Writer</h3>
                  <h5 className="text-gray-600 text-start">{contentItem.content_writer_name}</h5>
                </div>

                <div className="space-y-3 flex flex-col gap-4 w-full">
                  {contentItem.content && contentItem.content.length > 0 ? (
                    contentItem.content.map(
                      (c, index) =>
                        (c.headline || c.description) && (
                          <div key={index} className="bg-white rounded-md p-3 border border-gray-200 shadow-sm hover:shadow-md transition break-all text-start relative">
                            {/* Headline */}
                            {c.headline && (
                              <div className="flex items-center justify-between">
                                <div>
                                  <h5 className="font-semibold text-gray-700">{`Headline ${index + 1}`}</h5>
                                  <pre className="whitespace-pre-wrap break-words font-mono text-gray-700 bg-gray-100 p-2 rounded-md text-lg">{c.headline}</pre>
                                </div>
                                <button onClick={() => copyToClipboard(c.headline)} className="ml-2 text-gray-400 hover:text-gray-600 transition" title="Copy Headline">
                                  📋
                                </button>
                              </div>
                            )}

                            {/* Description */}
                            {c.description && (
                              <div className="mt-2 flex items-center justify-between">
                                <div>
                                  <h5 className="font-semibold text-gray-700">{`Description ${index + 1}`}</h5>
                                  <pre className="whitespace-pre-wrap break-words font-mono text-gray-600 bg-gray-50 p-2 rounded-md text-lg mt-2">{c.description}</pre>
                                </div>
                                <button onClick={() => copyToClipboard(c.description)} className="ml-2 text-gray-400 hover:text-gray-600 transition" title="Copy Description">
                                  📋
                                </button>
                              </div>
                            )}
                            {localStorage.getItem('role')===roles.ops && data.ad_type==="classified" && contentItem.approved!==c.id && <div className="flex justify-center items-center"><button className="px-2 py-1 rounded-md bg-green-400" onClick={()=>handleApproveContent(data.creative_id,contentItem.content_id,c.id,c.headline,c.description,onClose)}>Approve Content</button></div>}
                          </div>
                        )
                    )
                  ) : (
                    <p className="text-gray-400 text-center py-4">No headline/description found.</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center py-16 text-center">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 text-gray-300 mb-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m0 6a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            <h3 className="text-xl font-semibold text-gray-700">No Content Found</h3>
            <p className="text-gray-400 mt-2">Content Writer Not Assigned.</p>
          </div>
        )}

        {/* Footer */}
        <div className="flex justify-end mt-6 border-t border-gray-200 pt-3">
          <button onClick={onClose} className="px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition duration-200">
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContentDetailsModal;
